import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

/**
 * Pathless layout wrapping every route. Client-side navigations keep the
 * previous page's scroll offset, so without this a detail page opened from a
 * scrolled list appears "loaded in the middle". ScrollRestoration scrolls new
 * navigations to the top and restores the saved position on back/forward.
 */
export function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
